import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-common-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  standalone: true,
  imports: [CommonModule, NgIf, AngularSvgIconModule],
})
export class AccordionComponent implements OnInit {
  faq: any = {
    one: true,
    two: false,
    three: false,
  };

  constructor() {}

  ngOnInit(): void {}
}
